import React from 'react';
import CurrentUser from './CurrentUser';
import PendingUser from './PendingUser';
import CreateUser from './CreateUser';
import LoadingSpinner from '../LoadingSpinner';
import { hasGrant } from '../util/grantHelper';
import * as Grants from '../util/grants';
import './style.scss';


class Admin extends React.Component{
    constructor(props) {
        super(props);
        this.viewUserCommand=this.viewUserCommand.bind(this);
        this.state = {
            isLoading: true
        }
    }

    viewUserCommand(cmd, id)
    {   
        if (cmd >= 0)
        {
        this.setState({cmd: cmd, id: id});
        }   
    }
    

    render(){
        const { isLoading, apiToken } = this.props;
        let userInformationNode = <LoadingSpinner isLoading={true} />;
     
        if (this.state.cmd && this.state.cmd > 0)
        {
            userInformationNode = <CreateUser id={this.state.id} apiToken={apiToken} viewUserCommand={this.viewUserCommand} />;
        } else {
            userInformationNode = <div>
                                    <CurrentUser apiToken={apiToken} cmd={this.state.cmd} id={this.state.id} viewUserCommand={this.viewUserCommand}/> 
                                    {hasGrant(Grants.TYPES.Admin_ManagePendingUsers) && <PendingUser apiToken={this.props.apiToken} cmd={this.state.cmd} id={this.state.id} viewUserCommand={this.viewUserCommand}  /> }
                                  </div>
                                    
        }
        if (isLoading)
        {
            userInformationNode=undefined;
        }
        return(
            <div className="margin-top-10">
             {userInformationNode}
             </div>

        
        );
    }
}

export default Admin;